import {
    FETCH_SEARCH_RESULTS_START,
    FETCH_SEARCH_RESULTS_SUCCESS,
    FETCH_SEARCH_RESULTS_ERROR,
} from '../../constants';

export function getCategoryResults(data) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: FETCH_SEARCH_RESULTS_START,
                payload: {
                    loading: true
                }
            });

            if (data) {
                dispatch({
                    type: FETCH_SEARCH_RESULTS_SUCCESS,
                    payload: {
                        data,
                        loading: false
                    }
                });
            } else {
                dispatch({
                    type: FETCH_SEARCH_RESULTS_ERROR,
                    payload: {
                        loading: false
                    }
                });
            }

        } catch (error) {
            dispatch({
                type: FETCH_SEARCH_RESULTS_ERROR,
                payload: {
                    error,
                    loading: false
                }
            });
            return false;
        }
        return true;
    };
}

